import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { Button } from "antd";

export default function BatchReportsAlert(props) {
  const { onToggleModal, noResults } = props;
  return (
    <div>
      <SweetAlert
        confirmBtnBsStyle="btn-hide"
        onConfirm={() => {}}
        // eslint-disable-next-line
        style={{ width: "100%" }}
        title=""
      >
        <div className="batchReportsNoResults">
          {noResults.map((result, index) => (
            // eslint-disable-next-line react/no-danger
            <div className="batchReportsAlertText" key={index} dangerouslySetInnerHTML={{ __html: result }} /> // message is html string, it can contains <br> tags
          ))}
        </div>
        <div className="batchReportsAlertBtn">
          <Button type="primary" onClick={onToggleModal}>Confirm</Button>
        </div>
      </SweetAlert>
    </div>
  );
}
